

let administer = [
  {
      path: 'administer',
      name: '乡村治理',
      component: () => import("@/views/sellerAdmin/marketing/wares/index.vue"),
      children: [
        {
          path: 'overt',
          component: () => import("@/views/admin/supervise/administer/overt/index.vue"),
          name: '村务公开',
          meta: {
            hidden: true,
            key:18001
          },
        },
        {
          path: 'mailbox',
          component: () => import("@/views/admin/supervise/administer/mailbox/index.vue"),
          name: '村民信箱',
          meta: {
            hidden: true,
            key:18002
          },
        }
      ]
  }
]



let supply = [
  {
      path: 'supply',
      name: '供电服务',
      component: () => import("@/views/sellerAdmin/marketing/wares/index.vue"),
      children: [
        {
          path: 'safety',
          component: () => import("@/views/admin/supervise/supply/safety/index.vue"),
          name: '安全供电',
          meta: {
            hidden: true,
            key:25003
          },
        },
        {
          path: 'administration',
          component: () => import("@/views/admin/supervise/supply/administration/index.vue"),
          name: '供电所管理',
          meta: {
            hidden: true,
            key:25001
          },
        },
        {
          path: 'power',
          component: () => import("@/views/admin/supervise/supply/power/index.vue"),
          name: '供电服务管理',
          meta: {
            hidden: true,
            key:25002
          },
        },
      ]
  }
]
let synthesize = [
    {
        path: 'synthesize',
        name: '综合业务办理',
        component: () => import("@/views/sellerAdmin/marketing/wares/index.vue"),
        children: [
          // {
          //   path: 'resource',
          //   component: () => import("@/views/admin/supervise/synthesize/resource/index.vue"),
          //   name: '农业农村资源管理',
          //   meta: {
          //     hidden: true,
          //     key:19001
          //   },
          // },
          {
            path: 'xunjian',
            component: () => import("@/views/admin/supervise/synthesize/xunjian/index.vue"),
            name: '乡村违建巡检管理',
            meta: {
              hidden: true,
              key:19002
            },
          },
          {
            path: 'villager',
            component: () => import("@/views/admin/supervise/synthesize/villager/index.vue"),
            name: '村民管理',
            meta: {
              hidden: true,
              key:19003
            },
          }
        ]
    }
]


export const supervise = [
    {
        path: '/supervise',
        name: '管理服务系统',
        component: () => import("@/views/layout/index.vue"),
        children: [
            ...synthesize,//综合业务办理
            // ...administer,//乡村治理
            ...supply,//供电服务
        ]
    },

]
